import React, {useContext} from 'react';

const ConnectionListContext = React.createContext();

export const useConnectionListContext = () => useContext(ConnectionListContext);

export default ConnectionListContext;
